import { FileDownload } from '@mui/icons-material';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

import strings from 'constants/index';

interface TableExportButtonProps extends Omit<ButtonProps, 'onClick'> {
  onExport: () => void | Promise<void>;
  isExporting?: boolean;
  label?: string;
}

export const TableExportButton = ({
  onExport,
  isExporting = false,
  disabled,
  label = strings.export_csv,
  startIcon,
  variant = 'outlined',
  ...buttonProps
}: TableExportButtonProps) => (
  <Button
    {...buttonProps}
    data-testid="export-csv"
    disabled={disabled || isExporting}
    onClick={onExport}
    startIcon={
      isExporting ? <CircularProgress color="inherit" size={16} /> : startIcon ?? <FileDownload />
    }
    variant={variant}
  >
    {label}
  </Button>
);
